import React, {useContext} from "react";
import {enumNamesToSelect, Grid, FormHelperText} from "@leap4/frontend";
import {NotificationMethod} from "../../../enums";
import {GroupContext} from "../GroupContex";
import {TelegramParamsForm} from "../TypeParams/TelegramParamsForm"
import {initialMailParams, initialTelegramParams} from "../Group";
import {MailParamsForm} from "./MailParamsForm";

export const TypeParamsForm = () => {
    const GroupMethodSelect = enumNamesToSelect(NotificationMethod);
    const {group, setGroup} = useContext(GroupContext);

    const renderTypeParamsForm = ()=>{
        switch (group.method) {
            case NotificationMethod.TELEGRAM:{
                return <TelegramParamsForm />
            }
            case NotificationMethod.MAIL:{
                return <MailParamsForm/>
            }
            default:
                throw Error("group method is not defined correctly");

        }
    }

    const handleTypeChange = (e) =>{
        const newGroupMethod = e.target.value
        let groupParams;
        switch (newGroupMethod){
            case NotificationMethod.TELEGRAM:{
                groupParams = initialTelegramParams;
                break;
            }
            case NotificationMethod.MAIL:{
                groupParams = initialMailParams;
                break;
            }

            default:{
                throw new Error("group method is invalid")
            }
        }
        setGroup({...group,method: newGroupMethod, params: groupParams})
    }

    return <>
        <Grid container direction={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
            <Grid item xs={12} sm={8} md={6}>
                <FormHelperText>
                    Method
                </FormHelperText>
                <GroupMethodSelect
                    sx={{maxWidth: "400px"}}
                    required
                    fullWidth
                    value={group?.method}
                    onChange={handleTypeChange}
                    name="type"
                />

            </Grid>
            <Grid item sm={12}/>
            {renderTypeParamsForm()}

        </Grid>
    </>
}